import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../theme/styled';

import { Button } from './closeButton.styles';

export class CloseButton extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    iconColor: PropTypes.string,
  };

  static defaultProps = {
    iconColor: colors.darkGrey,
  };

  render() {
    return (
      <Button aria-label="close" {...this.props} />
    );
  }
}
